module.exports = __webpack_public_path__ + "static/media/pass.d8de7551.svg";